import {
    AfterViewChecked,
    Directive,
    ElementRef,
    HostBinding,
    HostListener,
    Input,
    OnInit,
    Renderer2
} from '@angular/core';
import tippy, {Instance, SingleTarget} from 'tippy.js';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';
import {PlatformControl} from '../../controls/core/platform/platform.control';
import {StringUtils} from '../utils/string.utils';

@Directive({selector: '[text-overflow]'})
export class TextOverflowDirective implements OnInit, AfterViewChecked {

    constructor(private el: ElementRef,
                private sanitizer: DomSanitizer,
                private renderer: Renderer2,
                public platformControl: PlatformControl) {
    }

    @Input('text-overflow') set setTextOverflow([maxWidth, maxLength, maxWidthToolTip]: [string, number, number | string]) {
        this._maxWidth = maxWidth ? maxWidth : this.determineMaxWidthDependsOnPlatform();
        this._maxWidthToolTip = maxWidthToolTip ? maxWidthToolTip : 1000;
        this._maxLength = maxLength ? maxLength : -1;
    }

    @HostBinding('class')
    className = 'text-overflow';

    @HostBinding('style')
    style: SafeStyle;

    tooltip: Instance;

    private _maxWidth: string;
    private _maxLength: number;
    private _maxWidthToolTip: number | string = 1000;
    private _tooltipContent: any;
    private _truncatedText:boolean = false;

    @HostListener('mouseover')
    onMouseOver() {
        if (this.isTextOverflow(this.el.nativeElement)) {
            if (!this.tooltip) {
                this.tooltip = tippy(this.el.nativeElement as SingleTarget, {
                    content: this._tooltipContent,
                    allowHTML: true,
                    showOnCreate: false,
                    maxWidth: this._maxWidthToolTip,
                });
            }
            this.tooltip.show();
        }
    }

    @HostListener('mouseout')
    onMouseOut() {
        this.tooltip?.hide();
    }

    isTextOverflow(nativeElement: any) {
        return this._truncatedText
            || nativeElement.offsetWidth < nativeElement.scrollWidth
            || nativeElement.firstChild?.offsetWidth < nativeElement.firstChild?.scrollWidth;
    }

    ngOnInit() {
        this.style = this.sanitizer.bypassSecurityTrustStyle(`max-width: ` + this._maxWidth);
    }
    ngAfterViewChecked(): void {
        // Save content before adapt it to avoid text-overflow on tooltip content
        if (!this._tooltipContent) {
            this._tooltipContent = this.el.nativeElement.innerHTML;
        }

        let content = StringUtils.removeHtml(StringUtils.unescapeHtml(this.el.nativeElement.innerHTML));
        if (!this._truncatedText && this._maxLength > 0 && content?.length > this._maxLength) {
            this._truncatedText = true;
            content = content.slice(0, this._maxLength) + '...';
        }
        this.el.nativeElement.innerText = content;

        if (this.el.nativeElement.hasChildNodes() && this.el.nativeElement.firstChild?.hasChildNodes()) {
            if (! this.el.nativeElement.firstChild.classList.contains('text-overflow')) {
                this.renderer.addClass(this.el.nativeElement.firstChild, 'text-overflow');
            }
        }
    }

    private determineMaxWidthDependsOnPlatform() {
        if (this.platformControl.isAtLeast(PlatformControl.LG)) {
            return '1000px';
        }
        if (this.platformControl.isAtLeast(PlatformControl.MD)) {
            return '300px';
        }
        return '100px';
    }
}

